// extracted by mini-css-extract-plugin
module.exports = {"seriesVideoList":"style_seriesVideoList__Rpne_"};